// extracted by mini-css-extract-plugin
module.exports = {"dialogOrderDetails":"DialogOrderDetails_dialogOrderDetails_2bJuV","isStyleDingBeauty":"DialogOrderDetails_isStyleDingBeauty_Mb29p"};